import { axiosGet, axiosPost } from "../../react_axios/Axios";
import { GET_APPLICATION_FORM_DETAILS_ACTION_TYPE, INSERT_UPDATE_APPLICATION_FORM_ACTION_TYPE, getApplicationFormDetailsUrl, insertUpdateApplicationFormUrl, headers, getApplicationFormDefaultDetailsUrl, getApplicantPaymentDetailsUrl, GET_APPLICATION_PAYMENT_DETAILS, GET_APPLICATION_FORM_DEFAULT_DETAILS_ACTION_TYPE, award_event_id, getApplicantPricingUrl, GET_APPLICANT_PRICING_ACTION_TYPE } from "../../utils/constants";



export const getApplicationFormDefaultDetails_action = (award_event_profile_id) => async (dispatch) => {

    try {
        const params = {
            UserID: sessionStorage.getItem("user_id"),
            award_event_id: sessionStorage.getItem("award_event_id"),
            Award_event_profile_id: award_event_profile_id
        }

        const res = await axiosGet(getApplicationFormDefaultDetailsUrl, params, headers)

        dispatch({
            type: GET_APPLICATION_FORM_DEFAULT_DETAILS_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getApplicationFormDetails_action = (application_form_id) => async (dispatch) => {

    try {
        const params = {
            UserID: sessionStorage.getItem("user_id"),
            application_form_id: application_form_id
        }

        const res = await axiosGet(getApplicationFormDetailsUrl, params, headers)

        dispatch({
            type: GET_APPLICATION_FORM_DETAILS_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getApplicationPaymentDetails_action = (application_form_id, award_event_profile_id) => async (dispatch) => {

    try {
        const params = {
            // UserID: sessionStorage.getItem("user_id"),
            award_event_id: sessionStorage.getItem("award_event_id"),
            application_form_id: application_form_id,
            award_event_profile_id: award_event_profile_id
        }

        const res = await axiosGet(getApplicantPaymentDetailsUrl, params, headers)

        dispatch({
            type: GET_APPLICATION_PAYMENT_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getApplicantPricing_action = (award_event_profile_id, country_id, state, applicant_type_id) => async (dispatch) => {

    try {
        const params = {
            award_event_id: sessionStorage.getItem("award_event_id"),
            award_event_profile_id: award_event_profile_id,
            country_id: country_id,
            state: state,
            applicant_type_id: applicant_type_id,
        }

        const res = await axiosGet(getApplicantPricingUrl, params, headers)

        dispatch({
            type: GET_APPLICANT_PRICING_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateApplicationForm_action = (application_form_id, applicant_id, application_no, award_event_id, award_event_profile_id, application_status_id, DeclarationFileName, DeclarationFileType, DeclarationFilePath, ApplicationFormList, declaration_file_path_db, is_paid, applicant_type_id, applicant_type_name, payment_type, is_gst_applicable, sme_certificate_FileName, sme_certificate_FileType, sme_certificate_FilePath, sme_certificate_file_path, award_name, cityName, stateName, countryId, pinCode, isAplicationIsPaid, isIncomplete) => async (dispatch) => {

    try {
        const params = {
            UserID: sessionStorage.getItem("user_id"),
            application_form_id: application_form_id != '' ? application_form_id : null,
            applicant_id: applicant_id != '' ? applicant_id : null,
            application_no: application_no != '' ? application_no : null,
            award_event_id: award_event_id != '' ? award_event_id : null,
            award_event_profile_id: award_event_profile_id != '' ? award_event_profile_id : null,
            application_status_id: application_status_id,
            DeclarationFileName: DeclarationFileName,
            DeclarationFileType: DeclarationFileType,
            DeclarationFilePath: DeclarationFilePath,
            ApplicationFormList: ApplicationFormList,
            declaration_file_path_db: declaration_file_path_db,
            is_paid: is_paid,
            applicant_type_id: applicant_type_id,
            applicant_type_name: applicant_type_name,
            payment_type: payment_type,
            is_gst_applicable: is_gst_applicable,
            sme_certificate_FileName: sme_certificate_FileName,
            sme_certificate_FileType: sme_certificate_FileType,
            sme_certificate_FilePath: sme_certificate_FilePath,
            sme_certificate_file_path: sme_certificate_file_path,
            award_name: award_name,
            city: cityName,
            state: stateName,
            country_id: countryId,
            pincode: pinCode != '' && pinCode != null ? parseInt(pinCode) : null,
            isAplicationIsPaid: isAplicationIsPaid,
            isIncomplete: isIncomplete,
        }

        const res = await axiosPost(insertUpdateApplicationFormUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_APPLICATION_FORM_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}